import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { authRepository } from "infra/repositories/auth-repository";
import FunctionHeader from "presentation/components/Header/FunctionHeader";
import { Logger } from "infra/logger/logger";
import { getSessionStorageItem, removeSessionStorageItem } from "presentation/utils/sessionStorage";
import moment from "moment";

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const email = useAuthStore((state) => state.email);
  const accessToken = useAuthStore((state) => state.accessToken);
  const logger = Logger.getInstance();

  useEffect(() => {
    const handleAuthCode = async () => {
      const params = new URLSearchParams(window.location.search);
      const authCode = params.get("code");
      // console.log("callback");

      if (authCode) {
        try {
          const codeVerifier = getSessionStorageItem("codeVerifier");

          if (!codeVerifier) {
            throw new Error("Code verifier não encontrado.");
          }

          if (!accessToken) {
            // console.log("gettoken");
            const token = await authRepository.token(authCode, codeVerifier);
            // console.log(token);
            if (token) {
              setAuth(token.data);
            }
          }
          logger.info(
            `Login by ${email} at ${moment().format("YYYY-MM-DD HH:mm:ss")}`
          );
          logger.debug(
            `Login by ${email} at ${moment().format("YYYY-MM-DD HH:mm:ss")}`
          );

          navigate("/");
          // window.location.href = "/intranet-dev";
        } catch (error: any) {
          console.error("Erro ao trocar o código por token:", error);
          logger.error("Login failed:" + error);
          
          // Mostrar mensagem mais específica baseada no tipo de erro
          let errorMessage = "Erro durante a autenticação. ";
          if (error.message.includes("Timeout")) {
            errorMessage += "O servidor não está respondendo. Tente novamente.";
          } else if (error.message.includes("temporariamente indisponível")) {
            errorMessage += "Serviço temporariamente indisponível. Tente novamente em alguns minutos.";
          } else if (error.message.includes("Erro interno do servidor")) {
            errorMessage += "Erro interno do servidor. Contate o administrador do sistema.";
          } else if (error.message.includes("Token do Azure inválido")) {
            errorMessage += "Problema na autenticação com Microsoft. Tente fazer login novamente.";
          } else if (error.message.includes("Erro ao obter token do Azure")) {
            errorMessage += "Problema na comunicação com Microsoft. Verifique sua conexão.";
          } else {
            errorMessage += "Verifique sua conexão e tente novamente.";
          }
          
          alert(errorMessage);
          
          // Limpar dados de autenticação em caso de erro
          removeSessionStorageItem("codeVerifier");
          
          navigate("/login");
        }
      } else {
        console.error("Código de autorização não encontrado.");
        // window.location.href = "/intranet-dev/login";
        logger.error("Código de autorização não encontrado.");
        navigate("/login");
      }
    };
    handleAuthCode();
  }, [accessToken, email, logger, navigate, setAuth]);

  return <FunctionHeader title="A validar credenciais" />;
};

export default AuthCallback;
